class AccordionComponent extends HTMLElement {
	constructor() {
		super();

		this.triggers = this.querySelectorAll('.accordion-group .trigger');

		this.triggers.forEach((trigger) => {
			const drawer = trigger.nextElementSibling;
			const parentGroup = trigger.parentElement;
			const isOpened = parentGroup.getAttribute('data-default-opened') === 'true';

			if (isOpened) {
				parentGroup.classList.add('active');
				drawer.setAttribute('style', `height: ${drawer.scrollHeight}px`);
			}

			trigger.addEventListener('click', this.handleTriggerClick.bind(this));
		});
	}

	handleTriggerClick({ currentTarget }) {
		const currentAccordion = currentTarget.parentElement;
		const isCurrentAccordionOpened = currentAccordion.classList.contains('active');
		const isDefaultOpened = currentAccordion.getAttribute('data-default-opened') === 'true';
		const drawerEl = currentTarget.nextElementSibling;

		if (isCurrentAccordionOpened && !isDefaultOpened) {
			drawerEl.removeAttribute('style');
			currentAccordion.classList.remove('active');
		} else if (!isCurrentAccordionOpened) {
			drawerEl.setAttribute('style', `height: ${drawerEl.scrollHeight}px`);
			currentAccordion.classList.add('active');
		}
	}
}

customElements.define('accordion-component', AccordionComponent);